import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import CustomerContactSelect from "components/Customer/CustomerContactSelect";
import ChangeCustomer from "./ChangeCustomer";

export default function QuoteInfo({
  formData,
  setFormData,
  refreshFunc,
  selectedQuote,
  disableCustomerSelect,
}) {
  /*   All States
   ********************************************* */
  const [showCustomerModal, setShowCustomerModal] = useState(false);

  const [showContactModal, setShowContactModal] = useState(false);

  /*   All Functions
   ********************************************* */

  // Quote Date is the quote's createdAt: the date the PDF prints (user,
  // 2026-10-30). Picked dates are saved at local noon so no timezone moves
  // them to the day before.
  const localDay = (value) => {
    if (!value) return "";
    const d = new Date(value);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const handleDateChange = (e) => {
    const day = e.target.value;
    if (!day) return;
    setFormData({ ...formData, createdAt: new Date(`${day}T12:00:00`).toISOString() });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectContact = (contact) => {
    //     {
    //     "id": 27,
    //     "contactId": 4,
    //     "companyId": 3,
    //     "customerId": 14,
    //     "sortId": 3,
    //     "firstName": "Alex",
    //     "lastName": "Javaid",
    //     "department": null,
    //     "phone": "12345678910",
    //     "mobile": null,
    //     "email": "info@printsportswear.com",
    //     "smsNotification": false,
    //     "createdAt": "2025-10-14T11:24:07.000Z",
    //     "updatedAt": "2025-10-14T11:42:36.000Z"
    // }
    setFormData((prev) => {
      return {
        ...prev,
        contactFirstName: contact?.firstName,
        contactLastName: contact?.lastName,
        contactDepartment: contact?.department,
        contactPhone: contact?.phone,
        contactEmail: contact?.email,
      };
    });
    setShowContactModal(false);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setFormData({
      contactFirstName: selectedQuote?.contactFirstName,
      contactLastName: selectedQuote?.contactLastName,
      contactDepartment: selectedQuote?.contactDepartment,
      contactPhone: selectedQuote?.contactPhone,
      contactEmail: selectedQuote?.contactEmail,
      jobName: selectedQuote?.jobName,
      createdAt: selectedQuote?.createdAt,
    });
  }, [selectedQuote]);

  return (
    <div className="bg-white custom-shadow flex-grow-1 px-3 pb-1 pt-3 custom-border-radius-sm">
      {/*   WO Info
       ********************************************* */}
      <div className="">
        <div className="d-flex justify-content-between align-items-center gap-3">
          <input
            type="text"
            className="form-control "
            value={formData?.jobName || ""}
            placeholder="Enter Job Name"
            name="jobName"
            onChange={handleChange}
          />
          <input
            type="date"
            className="form-control w-auto"
            title="Quote Date"
            aria-label="Quote Date"
            value={localDay(formData?.createdAt)}
            name="createdAt"
            onChange={handleDateChange}
          />

          <div className="d-flex align-items-center gap-3">
            <button
              disabled={!disableCustomerSelect}
              className="btn btn-info text-nowrap"
              onClick={() => setShowCustomerModal(true)}
            >
              Change Customer
            </button>
            <button
              disabled={!disableCustomerSelect}
              className="btn btn-info text-nowrap"
              onClick={() => setShowContactModal(true)}
            >
              Edit Contact
            </button>
          </div>
        </div>
        {/*   Customer Contact
         ********************************************* */}
        <div className="my-2 d-flex align-items-center justify-content-between gap-2">
          <input
            type="text"
            className="form-control"
            value={formData?.contactFirstName || ""}
            placeholder="Enter first name"
            name="contactFirstName"
            onChange={handleChange}
          />

          <input
            type="text"
            className="form-control"
            value={formData?.contactLastName || ""}
            placeholder="Enter last name"
            name="contactLastName"
            onChange={handleChange}
          />

          <input
            type="text"
            className="form-control"
            value={formData?.contactDepartment || ""}
            placeholder="Enter department"
            name="contactDepartment"
            onChange={handleChange}
          />

          <input
            type="text"
            className="form-control"
            value={formData?.contactPhone || ""}
            placeholder="Enter phone"
            name="contactPhone"
            onChange={handleChange}
          />

          <input
            type="text"
            className="form-control"
            value={formData?.contactEmail || ""}
            placeholder="Enter email"
            name="contactEmail"
            onChange={handleChange}
          />
        </div>
      </div>

      {/*   Customer Select Modal
       ********************************************* */}
      <Modal
        size="xl"
        contentClassName="bg-transparent"
        show={showCustomerModal}
        onHide={() => setShowCustomerModal(false)}
      >
        <Modal.Body>
          <ChangeCustomer
            selectedQuote={selectedQuote}
            showModal={setShowCustomerModal}
            refreshFunc={refreshFunc}
          />
        </Modal.Body>
      </Modal>
      {/*   Customer Contact Modal
       ********************************************* */}
      <Modal
        size="xl"
        contentClassName="bg-transparent"
        show={showContactModal}
        onHide={() => setShowContactModal(false)}
      >
        <Modal.Body>
          <CustomerContactSelect
            isPrimaryId={true}
            customerId={selectedQuote?.customerId}
            handleSelectContact={handleSelectContact}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
